var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _radialGradient, _path, _path2, _path3, _path4, _path5, _g, _path6, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 -584.7243)",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: -630.8914,
    y2: -664.2243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7026,
    stopColor: "#616161"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 -584.7243)",
    gradientUnits: "userSpaceOnUse",
    x1: 25.8673,
    x2: 101.8673,
    y1: -643.7743,
    y2: -643.7743
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0012001,
    stopColor: "#bfbebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#212121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8505,
    stopColor: "#212121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfbebe"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 127.8898)",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9,
    x2: 122.1,
    y1: 79.8398,
    y2: 79.8398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0012001,
    stopColor: "#bfbebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#212121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#212121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfbebe"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 -584.7243)",
    gradientUnits: "userSpaceOnUse",
    x1: 63.1,
    x2: 63.1,
    y1: -589.0576,
    y2: -627.5584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7151,
    stopColor: "#616161"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 64.1375,
    cy: -1462.6552,
    gradientTransform: "matrix(1 0 0 -.3995 0 -548.3682)",
    gradientUnits: "userSpaceOnUse",
    r: 8.6233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3965,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9968,
    stopColor: "#424242"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m102 66s-10.7 11.8-38.2 11.8-37.8-11.8-37.8-11.8v-25.7h76z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m102 66s-10.7 11.8-38.2 11.8-37.8-11.8-37.8-11.8v-25.7h76z",
    fill: "url(#b)",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m63 59.8-59-19.4-.1-3.9 118.2-.2v4z",
    fill: "#353535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m63 59.8-59-19.4-.1-3.9 118.2-.2v4z",
    fill: "url(#c)",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m63 55.9-59-19.4 59-15.7 59.2 15.5z",
    fill: "url(#d)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.2 35.3h-55.7c-1 0-1.9.7-2 1.6-.2 1.2.8 2.3 1.9 2.3h51.8c1.1 0 2 .9 2 2v55c0 1 .7 1.9 1.6 2.1 1.2.2 2.3-.8 2.3-1.9v-59.1c.1-1.1-.8-2-1.9-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.2 98.3c-1.1 0-2-.9-2-2v-59c0-1.1.9-2 2-2s2 .9 2 2v59.1c0 1.1-.9 1.9-2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.2 107.2c-2.2 0-6-2.7-5.9-4.9 0-.7.5-1.6 1.1-2.3 2-2.5 3.9-5.7 3.9-8.9v-3.6c0-1.1.9-2 2-2h1.9c1.1 0 2 .9 2 2 0 0 1.1 9.3-1 15.8-1.5 2.2-1.8 3.9-4 3.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.2,
    cy: 85.2,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.2 98.3c-1.1 0-2-.9-2-2v-59c0-1.1.9-2 2-2s2 .9 2 2v59.1c0 1.1-.9 1.9-2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.2 107.2c-2.2 0-6-2.7-5.9-4.9 0-.7.5-1.6 1.1-2.3 2-2.5 3.9-5.7 3.9-8.9v-3.6c0-1.1.9-2 2-2h1.9c1.1 0 2 .9 2 2 0 0 1.1 9.3-1 15.8-1.5 2.2-1.8 3.9-4 3.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.2,
    cy: 85.2,
    r: 4.1
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m62.5 37.3c0-1.1.9-2 2-2h55.8c1.1 0 2 .9 2 2s-.9 2-2 2h-55.9c-1-.1-1.9-.9-1.9-2z",
    fill: "#ffca28"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 37.3,
    fill: "url(#e)",
    rx: 8.1,
    ry: 3.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.dba6cda159a843f0264e93fe6ff94ae9.svg";
export { ForwardRef as ReactComponent };